import React, { useState, useEffect } from "react";
import "./component.css";
import leftArrow from "../../../assests/leftArrow.svg";
import { useNavigate } from "react-router-dom";
import Sidebar from "../../Navigation/Sidebar/Sidebar";

import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { Add as AddIcon, Remove as RemoveIcon } from "@mui/icons-material";
import uploadImage from "../../../assests/uploadImage.svg";
import CancelIcon from "@mui/icons-material/Cancel";
import dayjs from "dayjs";

import {
  TextField,
  Checkbox,
  Button,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Dialog,
  DialogTitle,
  DialogContent,
  Radio,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";

import { LocalizationProvider, DateTimePicker } from "@mui/x-date-pickers";

const ComboDetailsUpdateComponent = (props) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const isTablet = useMediaQuery(theme.breakpoints.between('sm', 'md'));

  React.useEffect(() => {
    if (props.formData.mv_config) {
      props.setMvConfig(props.formData.mv_config);
    }
  }, [props.formData]);

  useEffect(() => {
    if (props.formData && Object.keys(props.formData).length > 0) {
      props.setFormData(props.formData);
    }
  }, [props.formData]);

  // Convert date strings to dayjs objects
  const getStartDateValue = () => {
    if (props.formData.startDate) {
      return dayjs(props.formData.startDate);
    }
    return null;
  };

  const getEndDateValue = () => {
    if (props.formData.endDate) {
      return dayjs(props.formData.endDate);
    }
    return null;
  };

  // Handle radio button click
  const handleRadioClick = (e, item) => {
    e.stopPropagation();
    props.handleSelectMvId(item);
  };

  // Handle row click
  const handleRowClick = (item) => {
    props.handleSelectMvId(item);
  };

  // Simple price update - using native number input
  const updatePrice = (itemId, newValue) => {
    const updatedItems = props.selectedMvItems.map((item) =>
      item.id === itemId ? { ...item, price: newValue } : item
    );
    props.setSelectedMvItems(updatedItems);
  };

  const navigate = useNavigate();
  const handleClick = () => navigate(-1);

  return (
    <div className="main-div">
      <Sidebar />

      <div className="content-wrapper">
        <div className="header-section">
          <h2>
            <img
              onClick={handleClick}
              className="back-arrow"
              src={leftArrow}
              alt=""
            />{" "}
            Update Combo
          </h2>
        </div>

        <div className="form-container">
          <div className="form-content">
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <div className="form-column left-column">
                <TextField
                  name="name"
                  label="Name"
                  autoComplete="off"
                  fullWidth
                  variant="standard"
                  margin="normal"
                  value={(props.formData && props.formData.name) || ""}
                  onChange={props.handleInputChange}
                  sx={{
                    "& .MuiInput-underline:before": { borderBottomColor: "#14AE78" },
                    "& .MuiInput-underline:after": { borderBottomColor: "#14AE78" },
                  }}
                />
                {props.errors?.name && <span className="errortext">{props.errors.name}</span>}

                <TextField
                  name="description"
                  label="Description"
                  variant="standard"
                  fullWidth
                  margin="normal"
                  value={props.formData.description || ""}
                  onChange={props.handleInputChange}
                  sx={{
                    "& .MuiInput-underline:before": { borderBottomColor: "#14AE78" },
                    "& .MuiInput-underline:after": { borderBottomColor: "#14AE78" },
                  }}
                />
                {props.errors?.description && <span className="errortext">{props.errors.description}</span>}

                <TextField
                  name="mrp"
                  label="MRP"
                  variant="standard"
                  fullWidth
                  margin="normal"
                  type="number"
                  value={props.formData.mrp || ""}
                  onChange={(e) => {
                    const val = e.target.value;
                    props.handleInputChange({ target: { name: "mrp", value: val } });
                  }}
                  sx={{
                    "& .MuiInput-underline:before": { borderBottomColor: "#14AE78" },
                    "& .MuiInput-underline:after": { borderBottomColor: "#14AE78" },
                  }}
                />
                {props.errors?.mrp && <span className="errortext">{props.errors.mrp}</span>}

                <TextField
                  name="sellingPrice"
                  label="Selling Price"
                  variant="standard"
                  fullWidth
                  type="number"
                  margin="normal"
                  value={props.formData.sellingPrice || ""}
                  onChange={(e) => {
                    const val = e.target.value;
                    props.handleInputChange({ target: { name: "sellingPrice", value: val } });
                  }}
                  sx={{
                    "& .MuiInput-underline:before": { borderBottomColor: "#14AE78" },
                    "& .MuiInput-underline:after": { borderBottomColor: "#14AE78" },
                  }}
                />
                {props.errors?.sellingPrice && <span className="errortext">{props.errors.sellingPrice}</span>}

                <div className="date-picker-container">
                  <DateTimePicker
                    label="Starting Date"
                    value={getStartDateValue()}
                    onChange={(date) => props.handleDateChange("startDate", date)}
                    minDate={dayjs()}
                    slotProps={{
                      textField: {
                        variant: "standard",
                        sx: {
                          "& .MuiInput-underline:before": { borderBottomColor: "#14AE78" },
                          "& .MuiInput-underline:after": { borderBottomColor: "#14AE78" },
                        }
                      }
                    }}
                  />
                  {props.errors?.startDate && <span className="errortext">{props.errors.startDate}</span>}

                  <span className="date-separator">TO</span>

                  <DateTimePicker
                    label="Expire Date"
                    value={getEndDateValue()}
                    onChange={(date) => props.handleDateChange("endDate", date)}
                    minDate={getStartDateValue() || dayjs()}
                    slotProps={{
                      textField: {
                        variant: "standard",
                        sx: {
                          "& .MuiInput-underline:before": { borderBottomColor: "#14AE78" },
                          "& .MuiInput-underline:after": { borderBottomColor: "#14AE78" },
                        }
                      }
                    }}
                  />
                </div>
                {props.errors?.date && <span className="errortext">{props.errors.date}</span>}

                <div className="image-upload-section">
                  <p>Image</p>
                  {!(
                    props.formData.filePreview ||
                    props.formData.imagePreview ||
                    props.formData.imagePath ||
                    props.formData.image_url
                  ) ? (
                    <Button
                      variant="outlined"
                      component="label"
                      fullWidth
                      className="upload-button"
                    >
                      <div className="upload-content">
                        <img src={uploadImage} alt="Upload icon" />
                        <p>Choose file or drag here</p>
                      </div>
                      <input type="file" hidden onChange={props.handleFileChange} />
                    </Button>
                  ) : (
                    <div className="image-preview-container">
                      <img
                        src={
                          props.formData.filePreview ||
                          props.formData.imagePreview ||
                          props.formData.imagePath ||
                          props.fetchedImageUrl
                        }
                        alt="Selected file preview"
                        className="preview-image"
                      />
                      <IconButton
                        onClick={props.handleRemoveFile}
                        className="remove-image-button"
                      >
                        <CancelIcon fontSize="small" />
                      </IconButton>
                    </div>
                  )}
                </div>

                <Button
                  onClick={props.handleImageUpload}
                  variant="outlined"
                  color="success"
                  className="upload-submit-button"
                >
                  Upload Image
                </Button>

                {props.errors?.file && <span className="errortext">{props.errors.file}</span>}
              </div>

              <div className="form-column right-column">
                <div className="apply-on-section">
                  <p className="section-title">Apply on</p>
                  <div className="checkbox-group">
                    <Checkbox
                      name="applyOnKiosk"
                      style={{ color: "#14AE78" }}
                      checked={props.formData.applyOnKiosk || false}
                      onChange={(e) => props.handleCheckboxChange(e)}
                    />
                    Kiosk
                    <Checkbox
                      name="applyOnConsumerApp"
                      style={{ color: "#14AE78" }}
                      checked={props.formData.applyOnConsumerApp || false}
                      onChange={(e) => props.handleCheckboxChange(e)}
                    />
                    Consumer App
                  </div>
                  {props.errors?.selection && <span className="errortext">{props.errors.selection}</span>}
                </div>

                <div className="mv-id-section">
                  <div className="mv-id-input-container">
                    <TextField
                      label="Click to add MV ID"
                      fullWidth
                      disabled
                      value={props.mvId}
                      onChange={(e) => props.setMvId(e.target.value)}
                      className="mv-id-input"
                      variant="standard"
                      sx={{
                        "& .MuiInput-underline:before": { borderBottomColor: "#14AE78" },
                        "& .MuiInput-underline:after": { borderBottomColor: "#14AE78" },
                      }}
                    />

                    <Button
                      onClick={props.handleOpenModal}
                      className="add-mv-button"
                    >
                      Add
                    </Button>
                  </div>
                  {props.errors?.mvConfig && <span className="errortext">{props.errors.mvConfig}</span>}

                  <div className="selected-items-container">
                    {props.selectedMvItems?.length > 0 ? (
                      props.selectedMvItems.map((item, index) => {
                        const displayValue = item.price !== undefined && item.price !== null 
                          ? item.price 
                          : (item.mrp || "");
                        
                        return (
                          <div key={index} className="selected-item">
                            <span>{`ID: ${item.id}`}</span>
                            <input
                              type="number"
                              className="price-input-field-native"
                              value={displayValue}
                              onChange={(e) => {
                                const newValue = e.target.value;
                                updatePrice(item.id, newValue);
                              }}
                              style={{
                                width: "120px",
                                padding: "8px 12px",
                                border: "none",
                                borderBottom: "2px solid #14AE78",
                                fontSize: "14px",
                                outline: "none",
                                background: "transparent",
                                textAlign: "center",
                              }}
                            />
                            <div className="quantity-control">
                              <IconButton
                                onClick={() => props.decrementQuantity(item.id)}
                                className="quantity-button"
                              >
                                <RemoveIcon />
                              </IconButton>
                              <span className="quantity-value">{item.quantity}</span>
                              <IconButton
                                onClick={() => props.incrementQuantity(item.id)}
                                className="quantity-button"
                              >
                                <AddIcon />
                              </IconButton>
                            </div>
                          </div>
                        );
                      })
                    ) : (
                      <p className="no-items-text">No items available</p>
                    )}
                  </div>

                  <Dialog
                    open={props.modalOpen}
                    onClose={props.handleCloseModal}
                    maxWidth="md"
                    fullScreen={isMobile}
                    PaperProps={{
                      style: {
                        height: isMobile ? "100vh" : "80vh",
                        width: isMobile ? "100vw" : isTablet ? "80vw" : "70vw",
                        margin: isMobile ? 0 : "auto",
                        maxWidth: isMobile ? "none" : "70vw",
                      },
                    }}
                  >
                    <DialogTitle>
                      <Typography className="dialog-title">
                        Select an MV ID
                        <IconButton
                          onClick={props.handleCloseModal}
                          style={{ position: 'absolute', right: 8, top: 8 }}
                        >
                          <CancelIcon />
                        </IconButton>
                      </Typography>
                    </DialogTitle>

                    <DialogContent style={{ padding: isMobile ? '8px' : '24px' }}>
                      <TextField
                        label="Search MV ID"
                        fullWidth
                        type="text"
                        value={props.searchQuery}
                        onChange={props.handleSearchQueryChange}
                        variant="outlined"
                        style={{ marginBottom: '16px' }}
                      />

                      <div style={{
                        overflowX: 'auto',
                        width: '100%',
                        maxHeight: isMobile ? 'calc(100vh - 180px)' : '60vh'
                      }}>
                        <Table style={{ minWidth: isMobile ? '600px' : 'auto' }}>
                          <TableHead>
                            <TableRow>
                              <TableCell style={{
                                minWidth: '80px',
                                textAlign: 'center',
                                fontWeight: 'bold',
                                backgroundColor: '#f5f5f5'
                              }}>Select</TableCell>
                              <TableCell style={{
                                minWidth: '100px',
                                textAlign: 'center',
                                fontWeight: 'bold',
                                backgroundColor: '#f5f5f5'
                              }}>ID</TableCell>
                              <TableCell style={{
                                minWidth: '200px',
                                fontWeight: 'bold',
                                backgroundColor: '#f5f5f5'
                              }}>Product Name</TableCell>
                              <TableCell style={{
                                minWidth: '100px',
                                fontWeight: 'bold',
                                backgroundColor: '#f5f5f5'
                              }}>Price</TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {props.filteredMvList?.length > 0 ? (
                              props.filteredMvList.map((item, index) => {
                                const isSelected = props.selectedMvItems?.some(selected => selected.id === item.id);
                                return (
                                  <TableRow
                                    key={index}
                                    hover
                                    onClick={() => handleRowClick(item)}
                                    style={{ cursor: 'pointer' }}
                                  >
                                    <TableCell onClick={(e) => e.stopPropagation()} style={{ textAlign: 'center', padding: '12px' }}>
                                      <Radio
                                        checked={isSelected}
                                        value={item.id}
                                        onChange={() => props.handleSelectMvId(item)}
                                        onClick={(e) => handleRadioClick(e, item)}
                                      />
                                    </TableCell>
                                    <TableCell>{item.id}</TableCell>
                                    <TableCell>{item.variant_name || item.name}</TableCell>
                                    <TableCell>{item.mrp}</TableCell>
                                  </TableRow>
                                );
                              })
                            ) : (
                              <TableRow>
                                <TableCell colSpan={4} style={{ textAlign: 'center', padding: '20px' }}>
                                  No results found
                                </TableCell>
                              </TableRow>
                            )}
                          </TableBody>
                        </Table>
                      </div>
                    </DialogContent>
                  </Dialog>
                </div>
              </div>
            </LocalizationProvider>
          </div>
        </div>

        <div className="submit-button-container">
          <Button
            className="submit-button"
            onClick={props.handleUpdateComboApi}
          >
            Submit
          </Button>
        </div>
      </div>
    </div>
  );
};

export default ComboDetailsUpdateComponent;